import React from 'react'
import { isKambiSportsEventDetails, isKambiSportsSelection } from '@mobi/betslip/helpers/typeGuards'
import { QuickbetState, state$ as quickbetState$ } from '@core/Areas/Quickbet/driver'
import { observeImmutable } from '@core/Components/HOCs/observe'
import { BetInfoHeader, KambiSportsHeader, MultiHeader } from './Components'

export const BetSelectionInfo: React.ComponentClass = observeImmutable(
  quickbetState$,
  ({ record }) => {
    const { selection, selectionDetails, selectionMultiLegs, bettingType } =
      record.toJS() as QuickbetState

    if (selectionMultiLegs && selectionMultiLegs.length > 0) {
      return <MultiHeader legs={selectionMultiLegs} />
    }

    if (bettingType === 'kambi-sports') {
      const isValidSportsInfo =
        isKambiSportsSelection(selection) && isKambiSportsEventDetails(selectionDetails)

      if (!isValidSportsInfo) {
        // TODO: Handle invalid bet information
        // * Can use localised error boundary within Quickbet?
        return null
      }

      return <KambiSportsHeader selection={selection} eventDetails={selectionDetails} />
    }

    return <BetInfoHeader selectionDetails={selectionDetails} />
  }
)
